import * as THREE from "three";
import { MTLLoader, OBJLoader } from "three-stdlib";
import Deck from "./Deck";

export default class Boat extends THREE.Group {
  constructor(config, loadedCallback, scene) {
    super();

    this.config = config;
    this.rotation.y = Math.PI;

    new MTLLoader().load(config.materials, materials => {
      materials.preload();
      this.materials = materials;

      new OBJLoader().setMaterials(materials).load(config.model, object => {
        // object.rotation.x = - Math.PI / 2;
        // object.rotation.y = Math.PI;
        object.castShadow = true;
        object.receiveShadow = true;

        let max = 0;
        object.traverse(child => {
          if (child instanceof THREE.Mesh) {
            child.castShadow = true;
            child.receiveShadow = true;

            for (const position of child.geometry.attributes.position.array) {
              const absPosition = Math.abs(position);
              if (absPosition > max) {
                max = absPosition;
              }
            }
          }
        });

        this.add(object);
        //
        this.mesh = object;
        this.maxPosition = max;

        // Let the scene know the boat is ready for business
        loadedCallback();
      });
    });

    this.time = 0;

    if (config.decks) {
      for (const deck of config.decks) {
        const d = new Deck(deck, scene);

        this.add(d);
      }
    }
  }

  /**
   * Called every frame before render time
   */
  update() {
    this.time += 1 / 60;

    // Need to ensure mesh is loaded
    if (this.config.disableRocking !== true && this.mesh) {
      // This rocks the boat.
      this.rotation.y = Math.PI + Math.sin(this.time) * 0.02;
      this.rotation.x = Math.sin(1.3 * this.time + 15) * 0.02;
    }
  }

  /**
   * Sets the opacity of the shell of the boat
   */
  setOpacity(opacity) {
    for (const m of Object.keys(this.materials.materials)) {
      const mat = this.materials.materials[m];

      mat.transparent = true;
      mat.opacity = opacity;
    }
  }
}
